import { useCallback } from 'react'

import { DatahubEvent } from '@space-lib/datahub'
import type { DatahubEventProps } from '@space-lib/datahub'
import { useAuthStore, useMembershipStore } from '@space-shell/core/store'

import useThemeContext from '../useThemeContext'

export const useDataHubEvents = () => {
  const { membershipData } = useMembershipStore()
  const { id: userId, locale } = useAuthStore()
  const { theme } = useThemeContext()

  const sendDataHubEvent = useCallback(
    ({ group, name, params }: DatahubEventProps) => {
      DatahubEvent.send({
        group,
        name,

        params: {
          creator: {
            id: membershipData?.ownerId,
            name: membershipData?.name,
            product: membershipData?.slug,
            orientation: membershipData?.settings?.orientation,
            membershipId: membershipData?.id
          },

          user: {
            id: userId,
            agent: String(window.navigator.userAgent),
            locale
          },

          ...(params && { ...params }),

          theme: {
            mode: theme
          }
        },

        user: {
          id: userId
        },

        path: window.location.pathname,
        queryParams: window.location.search
      })
    },
    [
      locale,
      membershipData?.name,
      membershipData?.id,
      membershipData?.ownerId,
      membershipData?.settings?.orientation,
      membershipData?.slug,
      theme,
      userId
    ]
  )

  return { sendDataHubEvent }
}
